import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'
import { useAuthStore } from '@/stores/auth'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/',
    redirect: '/demand/audit',
    component: () => import('@/components/Layout/index.vue'),
    children: [
      {
        path: 'demand/audit',
        name: 'DemandAudit',
        component: () => import('@/views/demand/audit.vue'),
        meta: { title: '需求审核' }
      },
      {
        path: 'artist/audit',
        name: 'ArtistAudit',
        component: () => import('@/views/artist/audit.vue'),
        meta: { title: '乙方审核' }
      },
      {
        path: 'product/audit',
        name: 'ProductAudit',
        component: () => import('@/views/product/audit.vue'),
        meta: { title: '商品审核' }
      },
      {
        path: 'order/manage',
        name: 'OrderManage',
        component: () => import('@/views/order/manage.vue'),
        meta: { title: '订单管理' }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由拦截器
router.beforeEach((to, _from, next) => {
  const authStore = useAuthStore()
  const token = authStore.token

  // 设置页面标题
  if (to.meta.title) {
    document.title = `${to.meta.title} - 小火柴后台管理系统`
  }

  // 登录页直接放行
  if (to.path === '/login') {
    if (token) {
      // 已登录则跳转首页
      next('/')
    } else {
      next()
    }
    return
  }

  // 其他页面需要验证登录状态
  if (!token) {
    next('/login')
  } else {
    next()
  }
})

export default router

